import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useOptionalSession } from 'src/contexts/SessionContext';
import { FeatureFlag } from 'src/models/platform/_types';
import { getCombinedClientNavItems } from 'src/models/platform/utils';
import { isTrainer } from 'src/models/user/utils';
import {
  clientRoutesExtraData,
  routesExtraData,
} from 'src/shared/AppFrame/routeConfig';
import { hasFeatureFlag } from 'src/shared/usePermissionCheck';
import toast from 'src/utils/toast';

import ErrorPage from './Error';

export const IndexPage = () => {
  const { session, user } = useOptionalSession();
  const [searchParams] = useSearchParams();

  const flash = searchParams.get('flash');

  useEffect(() => {
    if (flash) {
      toast.error(flash);
    }
  }, [flash]);

  if (!user?.id) {
    return <Navigate to="/login" replace />;
  }

  // For clients, use combined navigation items
  const navItems = isTrainer(user)
    ? session?.platformTabs['trainerDashboard']
    : getCombinedClientNavItems(session?.platformTabs);

  // Find first enabled menu item, excluding external links for clients
  const firstEnabledItem = navItems?.find(
    (item) =>
      item.enabled &&
      (isTrainer(user) || !clientRoutesExtraData[item.id]?.externalLink)
  );

  if (!firstEnabledItem) {
    return (
      <ErrorPage
        type={404}
        title="No Menu Items Available"
        message="There are no enabled menu items available for your account."
      />
    );
  }

  const reactRoute = routesExtraData[firstEnabledItem.id]?.reactRoute;

  if (
    session &&
    ((firstEnabledItem.id == 'Dashboard' &&
      !hasFeatureFlag(session, FeatureFlag.NewDashboard)) ||
      (firstEnabledItem.id == 'Clients' &&
        !hasFeatureFlag(session, FeatureFlag.NewClientsPage)))
  ) {
    // Redirect to new old dashboard
  } else if (reactRoute) {
    return <Navigate to={reactRoute} replace />;
  }

  // Use the original route with /embed/ prefix
  let route = firstEnabledItem.route.replace(/^\//, ''); // Remove leading slash if present

  if (route.startsWith('dashboard/fbm/schedule')) route = 'fbm/schedule/';

  return <Navigate to={`/embed/${route}`} replace />;
};
